export default __webpack_public_path__ + "static/media/Restore-Defaults.e01e4afc.jpg";